import {
  IntegrationProvidersTypes,
  IntegrationDeliveryTypes,
} from '~globals/types/enums';
import { SelectOption } from '~globals/types';
import { toAbsoluteUrl } from '~utils/assetsHelpers';

export const integrationsProviders = [
  {
    type: IntegrationProvidersTypes.MercadoLibre,
    name: 'MercadoLibre',
    logo: {
      url: toAbsoluteUrl('/images/mp_logo.png'),
      alt: 'MercadoLibre Logo',
    },
    logoSmall: {
      url: toAbsoluteUrl('/images/mp_small_logo.png'),
      alt: 'MercadoLibre Logo Small',
    },
    imgPrompt: {
      url: toAbsoluteUrl('/images/mp_prompt.png'),
      alt: 'Autorize Routix on MercadoLibre',
    },
  },
  {
    type: IntegrationProvidersTypes.TiendaNube,
    name: 'Tienda Nube',
    logo: {
      url: toAbsoluteUrl('/images/tn_logo.png'),
      alt: 'Tienda Nube Logo',
    },
    logoSmall: {
      url: toAbsoluteUrl('/images/tn_small_logo.png'),
      alt: 'Tienda Nube Logo Small',
    },
    imgPrompt: {
      url: toAbsoluteUrl('/images/tn_prompt.png'),
      alt: 'Autorize Routix on Tienda Nube',
    },
  },
  {
    type: IntegrationProvidersTypes.WooCommerce,
    name: 'WooCommerce',
    logo: {
      url: toAbsoluteUrl('/images/woo_logo.png'),
      alt: 'WooCommerce Logo',
    },
    logoSmall: {
      url: toAbsoluteUrl('/images/woo_small_logo.png'),
      alt: 'WooCommerce Logo Small',
    },
    imgPrompt: {
      url: toAbsoluteUrl('/images/woo_prompt.png'),
      alt: 'Autorize Routix on WooCommerce',
    },
  },
  {
    type: IntegrationProvidersTypes.Shopify,
    name: 'Shopify',
    logo: {
      url: toAbsoluteUrl('/images/shopify_logo.png'),
      alt: 'Shopify Logo',
    },
    logoSmall: {
      url: toAbsoluteUrl('/images/shopify_small_logo.png'),
      alt: 'Shopify Logo Small',
    },
    imgPrompt: {
      url: toAbsoluteUrl('/images/shopify_prompt.png'),
      alt: 'Autorize Routix on Shopify',
    },
    commingSoon: true,
  },
];

export const MERCADO_LIBRE_SHIPPING_OPTIONS: SelectOption[] = [
  {
    label: 'Mercado Envíos 1',
    value: IntegrationDeliveryTypes.ME1,
  },
  {
    label: 'Mercado Envíos 2',
    value: IntegrationDeliveryTypes.DropOff,
  },
  {
    label: 'Mercado Envíos Places',
    value: IntegrationDeliveryTypes.XdDropOff,
  },
  {
    label: 'Mercado Envíos Colecta',
    value: IntegrationDeliveryTypes.CrossDocking,
  },
  {
    label: 'Mercado Envios Flex y Turbo',
    value: IntegrationDeliveryTypes.SelfService,
  },
  {
    label: 'Otros envíos',
    value: IntegrationDeliveryTypes.Custom,
  },
];
